import React, { useEffect, useRef, useState } from "react";
import Button from "./ui/button";

const NewGame = ({ onCreate, timeCreate }) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        infoRef.current &&
        !infoRef.current.contains(event.target)
      ) {
        setShowInfo(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  return (
    <div className="btn-head-games">
      {timeCreate && (
        <span className="timestamp-game">
          {new Date(timeCreate).toLocaleString("vi-VN", {
            weekday: "short",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      )}

      <Button onClick={onCreate}>
        New Game
      </Button>

      
        <button
          type="button"
          onClick={() =>
            setShowInfo((prev) => !prev)
          }
          aria-label="Thông tin"
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-gray-400 text-sm font-semibold text-gray-600 hover:bg-gray-100"
        >
          i
        </button>

        {showInfo && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3 className="modal-title">
                Thông tin sử dụng
              </h3>

              <p>
                Đây là một trong những công cụ miễn phí
                được phát triển bởi JangThien.
                Việc sử dụng công cụ thuộc trách nhiệm
                của người dùng.
              </p>

              <div className="flex justify-center mt-4">
                <Button
                  onClick={() => setShowInfo(false)}
                  className="cancel-button bg-gray-500 text-white"
                >
                  Đóng
                </Button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default NewGame;